import type { Case } from "../../api/types.ts"
import { useT } from "../../i18n/index.tsx"
import { DocBadge, StatusBadge } from "../badges.tsx"

/**
 * 반품 상세의 머리.
 *
 * 옆판에서는 헤더가 이미 건 번호를 들고 있으므로 제목을 끄고 뱃지 줄만 그린다.
 */
export function CaseHeader({ item, showHeading }: { item: Case; showHeading: boolean }) {
  const t = useT()
  return (
    <header className="case-head">
      {showHeading ? (
        <h1 className="case-head__title">
          {t("caseDetail.title")} #{item.seq}
          <span className="case-head__order">{item.orderNo}</span>
        </h1>
      ) : null}
      <div className="case-head__badges">
        <StatusBadge status={item.status} />
        <DocBadge docStatus={item.docStatus} />
        <span className="case-head__who">{item.customerName}</span>
      </div>
    </header>
  )
}
